import { render } from "./created-contact.vue?vue&type=template&id=a31c6042"
import script from "./created-contact.vue?vue&type=script&lang=js"
export * from "./created-contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__